import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
const sameCategory = (item, index, array) =>
  (index > 0 && array[index - 1].category === array[index].category) ||
  item.showAll;

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => (
  <ul className="quick-search-result">
    {result &&
      result.map((item, index, array) => (
        <Fragment key={`${item.name}-${index}`}>
          {item.category === 'NoHit' ||
          sameCategory(item, index, array) ? null : (
            <li className="quick-search-result__item quick-search-result__group-header">
              {item.category}
            </li>
          )}
          <li
            className={`quick-search-result__item ${
              selectedItem === index
                ? 'quick-search-result__item--selected'
                : ''
            }`}
          >
            {!item.showAll ? (
              <a
                className={
                  item.showAll
                    ? 'quick-search-result__show-all'
                    : `quick-search-result__link ${
                        item.url ? '' : 'quick-search-result__link--disabled'
                      }`
                }
                href={item.category !== 'NoHit' ? item.url : ''}
              >
                <div className="columns small-2 large-2 quick-search-result__image-column">
                  {item.hasImage && item.imageSource && (
                    <img
                      className="quick-search-result__image"
                      src={item.imageSource}
                    />
                  )}
                </div>
                <div className="columns small-10 large-10 quick-search-result__text">
                  {item.name}
                </div>
              </a>
            ) : (
              <div className="quick-search-result__show-all">
                <div className="columns small-9 medium-10 large-10">
                  <a href={item.showAll ? searchUrl : item.url}> {item.name}</a>
                </div>
              </div>
            )}
          </li>
        </Fragment>
      ))}
  </ul>
);

export default QuickSearchResult;
